import { render, staticRenderFns } from "./orderRouter.vue?vue&type=template&id=05801df0&scoped=true"
import script from "./orderRouter.vue?vue&type=script&lang=js"
export * from "./orderRouter.vue?vue&type=script&lang=js"
import style0 from "./orderRouter.vue?vue&type=style&index=0&id=05801df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05801df0",
  null
  
)

export default component.exports